<template>
  <div class="story-medium">
    <div class="media">
      <div class="media-left" ref="thumbnail">
        <a class="image" :href="url" target="_blank" ref="linkTooltip" data-toggle="tooltip" data-trigger="hover" :title="mediaFileName">
          <img v-if="fileType == 'image'" :src="small_thumb_url" width="100">
          <div class="file-icon" v-if="fileType != 'image'">
            <i class="fa fa-file"></i>
          </div>
        </a>
      </div>

      <div class="media-body">
        <div>
          <a class="media-filename text-muted" :href="url" v-text="mediaFileName" v-if="filename"></a>
        </div>
        <Label :text="credit" v-if="credit" />
        <div v-html="cutline"></div>

        <div class="text-right">
          <LabelledCheckbox label="Print" :modelValue="for_print" />
          <LabelledCheckbox label="Web" :modelValue="for_web" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapStores } from 'pinia'
  import { useStoryMediaStore } from '@/stores/story_media'
  import { mediaFileName } from '@/utils/file_helpers'
  import LabelledCheckbox from '@/components/shared/labelled_checkbox.vue'
  import Label from '@/components/shared/label.vue'

  export default {
    components: {
      LabelledCheckbox,
      Label
    },

    props: {
      id: {
        type: Number,
        required: true
      }
    },

    computed: {
      ...mapStores(useStoryMediaStore),

      storyMedium() {
        return this.storyMediaStore.storyMedia[this.id]
      },

      use_as_content_for() { return this.storyMedium?.use_as_content_for },
      for_print() { return this.storyMedium?.for_print },
      for_web() { return this.storyMedium?.for_web },
      cutline() { return this.storyMedium?.medium?.cutline },
      credit() { return this.storyMedium?.medium?.credit },
      url() { return this.storyMedium?.medium?.url },
      small_thumb_url() { return this.storyMedium?.medium?.small_thumb_url },
      file() { return this.storyMedium?.medium?.file },
      filename() { return this.storyMedium?.medium?.filename },
      content_type() { return this.storyMedium?.medium?.content_type },

      fileType() {
        if (this.content_type != null) {
          return this.content_type.split('/')[0]
        }
      },

      mediaFileName() {
        return mediaFileName(this.filename)
      },
    },

    mounted() {
      if(this.$refs.linkTooltip) {
        jQuery(this.$refs.linkTooltip).tooltip()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .story-medium {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 2px solid #c9c9c9;

    .media-filename {
      max-width: 250px;
      overflow: hidden;
    }

    .text-right {
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
      gap: 15px;
      align-items: center;
    }
  }
  img {
    max-width: 110px;
    max-height: 110px;
    object-fit: contain;
  }
  .media-left {
    a.image {
      position: relative;
      display: block;
    }
  }
  .file-icon {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
</style>
